import {getAllEntitiesApply, selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';
import {purchaseStatementsStore} from '@store/invoices/purchaseStatements/purchaseStatements.store';
import {getPurchaseStatementsDataSource} from '@store/invoices/purchaseStatements/purchaseStatements.requests';

export class PurchaseStatementsQuery {
  store = purchaseStatementsStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  purchaseStatements$ = getPurchaseStatementsDataSource.data$();
  selectedPurchaseStatements$ = this.store.pipe(
    selectManyByPredicate((purchaseStatementUi) => purchaseStatementUi.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get selectedPurchaseStatement() {
    return this.store.query(
      getAllEntitiesApply({
        mapEntity: (e) => e.id,
        filterEntity: (e) => e.selected,
        ref: UIEntitiesRef,
      })
    );
  }

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const purchaseStatementsQuery = new PurchaseStatementsQuery();
